import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchResultCard, Button, Chip } from '@origo/origo-ui';
import type { PlanSummary } from '../../../types';

interface PlanResultCardProps {
    plan: PlanSummary;
    /** Klikk på kort = zoom kartet til planen. Drømmeplan-admin-mønster. */
    onZoomTo: (id: string) => void;
    /** Klikk på "Velg" = gå inn i planregistreringsflyten for planen. */
    onSelect: (id: string) => void;
}

const PlanResultCard: React.FC<PlanResultCardProps> = ({ plan, onZoomTo, onSelect }) => {
    const { t } = useTranslation();

    const subtitle = plan.sistEndret && plan.sistEndretAv
        ? t('landing.recent.lastEditedBy', { date: plan.sistEndret, user: plan.sistEndretAv })
        : plan.sistEndret
            ? t('landing.recent.lastEdited', { date: plan.sistEndret })
            : undefined;

    // Statusbadge — første badge i listen vises i status-slot. Drømmeplan-
    // admin-mønster: én chip i header for primær status (her: planstatus).
    const primaryBadge = plan.badges?.[0];
    const status = primaryBadge ? (
        <Chip variant={primaryBadge.variant ?? 'default'}>{primaryBadge.label}</Chip>
    ) : undefined;

    return (
        <SearchResultCard
            title={plan.plannavn}
            subtitle={subtitle}
            status={status}
            onClick={() => onZoomTo(plan.nasjonalArealplanId)}
            secondaryAction={
                <Button
                    variant="primary"
                    size="md"
                    onClick={() => onSelect(plan.nasjonalArealplanId)}
                >
                    {t('landing.recent.select')}
                </Button>
            }
        />
    );
};

export default PlanResultCard;
